import { CREATE_NEW_VERSION_REQUEST, CREATE_NEW_VERSION_SUCCEEDED, CREATE_NEW_VERSION_FAILED,
  FETCH_VERSIONS_REQUEST, FETCHING_VERSIONS_SUCCEEDED, FETCHING_VERSIONS_FAILED,
  DELETING_VERSION_FAILED, DELETING_VERSION_SUCCEEDED, DELETE_VERSION_REQUEST,
  FETCH_VERSION_REQUEST, FETCHING_VERSION_SUCCEEDED, FETCHING_VERSION_FAILED,
  RESTORE_VERSION_REQUEST, RESTORING_VERSION_SUCCEEDED, RESTORING_VERSION_FAILED, INVALIDATE_RESTORE_STATE,
  RENAME_VERSION_REQUEST, RENAMING_VERSION_SUCCEEDED, RENAMING_VERSION_FAILED, INVALIDATE_CREATE_STATE,
} from "constants/actionTypes";

import _ from "lodash";

const initialState = {
  loading: false,
  restoring: false,
  createdState: {},
  items: [],
  preview: [],
  error: false,
};

export function versionsReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_NEW_VERSION_REQUEST: {
      return {
        ...state,
        createdState: {
          creating: true,
          success: false,
          error: false
        },
      };
    }

    case CREATE_NEW_VERSION_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      return {
        ...state,
        createdState: {
          creating: false,
          success: true,
          error: false
        }
      };
    }

    case CREATE_NEW_VERSION_FAILED: {
      return {
        ...state,
        createdState: {
          creating: false,
          success: false,
          error: true
        }
      };
    }
    
    case INVALIDATE_CREATE_STATE: {
      return {
        ...state,
        createdState:{}
      }
    }

    case FETCH_VERSIONS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCHING_VERSIONS_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      const items = action.payload;

      return {
        ...state,
        items: items,
        error: false,
      };
    }

    case FETCHING_VERSIONS_FAILED: {
      return {
        ...state,
        error: true,
      };
    }

    case DELETE_VERSION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case DELETING_VERSION_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      let versionID = action.payload;
      const updatedItems = _.filter(
        state.items,
        (item) => item.id !== versionID
      );

      return {
        ...state,
        items: updatedItems,
        error: false,
      };
    }

    case DELETING_VERSION_FAILED: {
      return {
        ...state,
        error: true,
      };
    }

    case FETCH_VERSION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case FETCHING_VERSION_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      let previewWidgets = _.get(action.payload, "pageResponse.content.widgets");

      return {
        ...state,
        preview: previewWidgets,
        loading: false,
        error: false,
      };
    }

    case FETCHING_VERSION_FAILED: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    case RESTORE_VERSION_REQUEST: {
      return {
        ...state,
        restoring: true,
      };
    }

    case RESTORING_VERSION_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      return {
        ...state,
        restoring: false,
        error: false,
      };
    }

    case RESTORING_VERSION_FAILED: {
      return {
        ...state,
        restoring: false,
        error: true,
      };
    }

    case INVALIDATE_RESTORE_STATE: {
      return {
        ...state,
        restoring: false
      }
    }

    case RENAME_VERSION_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case RENAMING_VERSION_SUCCEEDED: {
      if (!action.payload) {
        return;
      }

      const version = action.payload;
      const updatedItems = _.map(state.items, (item) => {
        if (item.id === version.id) {
          return { ...item, name: version.name };
        }

        return item;
      });

      return {
        ...state,
        items: updatedItems,
        loading: false,
        error: false,
      };
    }
    case RENAMING_VERSION_FAILED: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    default:
      return state;
  }
}
